/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */import Pagination from "components/Pagination/Pagination";
import TableOrder from "components/Tables/TableOrder";
import React, { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { SectionContainerGene } from "styled/SectionContainer.styled";
import ConfigurationHeader from "../ConfigurationHeader";
import queryString from "query-string";
import { ZonesControlTitle } from "../ArrayTitles";
import ConfigurationCRUDContext from "context/ConfigurationCRUDContext";
import { FormZonesControl } from "../forms/FormZonesControl";

const formEdit = () => {
  return <FormZonesControl />;
};

//   const formShow = () => {
//     return <FormSubheadingShow />;
//   };

export const ZonesControl = () => {
  const [currentPage, setCurrentPage] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [maxPage, setMaxPage] = useState(1);
  const location = useLocation();
  const token = useSelector((state) => state.auth.dataUser.token);
  const { q = "" } = queryString.parse(location.search);
  // const { authUser } = useContext(AuthContext);
  const {
    // setRequestEdit,
    // setRequestCreate,
    // setRequestDelete,
    setFormEdit
    // setFormShow,
    // update,
  } = useContext(ConfigurationCRUDContext);

  useEffect(() => {
    setFormEdit(formEdit);
  }, [setFormEdit]);

  return (
    <>
      <SectionContainerGene>
        <ConfigurationHeader title="Control de zonas francas"></ConfigurationHeader>
        {loading || (
          <TableOrder
            thead={ZonesControlTitle}
            data={currentPage}
            setData={setCurrentPage}
            loading={loading}
            tbodyData={[]}
          />
        )}
        <Pagination
          page={page}
          setPage={setPage}
          maxPage={maxPage}
          loading={loading}
        />
      </SectionContainerGene>
    </>
  );
};
